module.exports = __webpack_public_path__ + "media/images/icons/icons_large/25_crossedbullets-a3925113ce5bf6040bc8de86d85ef18f.png";